import constants from 'common/constants'

import {ONBOARDING_EXTRACT_TEACHERS} from './ActionTypes/ApiActionTypes'

/**
 * Send one uploaded teacher-list file (Word, PDF, image, or a spreadsheet with no
 * recognisable header) to the server-side extraction endpoint. `body` is a FormData with
 * a single `file` field; the response contract is documented in
 * docs/onboarding-teacher-extraction-api.md.
 */
export const extractOnboardingTeachers = (body, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_EXTRACT_TEACHERS,
    payload: {
      apiUrl: constants.api_onboarding_extract_teachers,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'multipart/form-data',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
